export default class ScreenWake {
  wakeLock = null

  isSupported() {
    return "wakeLock" in navigator
  }

  async keepAwake() {
    if (this.isSupported()) {
      this.wakeLock = await navigator.wakeLock.request("screen")
    } else {
      this.wakeLock = null
    }
  }

  async release() {
    if (this.wakeLock) {
      await this.wakeLock.release()
      this.wakeLock = null
    }
  }
}
